import { render, staticRenderFns } from "./App.vue?vue&type=template&id=480557ea&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=480557ea&prod&lang=scss"
import style1 from "./App.vue?vue&type=style&index=1&id=480557ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480557ea",
  null
  
)

export default component.exports